import { FormattedMessage } from 'react-intl';

const DesktopSummaryModalContent = (props) => {
  return (
    <div className='summary-modal'>
      <span className='summary-modal-title'>
        <FormattedMessage id='Summary' />
      </span>
      <div className='summary-table-wrapper'>
        <table className='summary-table'>
          <thead>
            <tr className='summary-table-header'>
              <th className='amount'>
                <FormattedMessage id='Sum gross' />
              </th>
              <th className='currency'>
                <FormattedMessage id='Currency' />
              </th>
            </tr>
          </thead>
          <tbody>
            {props.currencies.map((currency) => {
              return (
                <tr key={currency}>
                  <td className='amount'>{props.displayValueForCurrency(props.grossValueSummary, currency)}</td>
                  <td className='currency'>{currency}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DesktopSummaryModalContent;
